import React from 'react';
import { DocumentTextIcon, ChartBarIcon } from '@heroicons/react/24/outline';

interface NavigationProps {
  currentPage: 'expenses' | 'kpi';
  onPageChange: (page: 'expenses' | 'kpi') => void;
}

const Navigation: React.FC<NavigationProps> = ({ currentPage, onPageChange }) => {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t shadow-lg z-40">
      <div className="flex justify-around py-2">
        <button
          onClick={() => onPageChange('expenses')}
          className={`flex flex-col items-center p-3 transition-colors ${
            currentPage === 'expenses' ? 'text-blue-600' : 'text-gray-500'
          }`}
        >
          <DocumentTextIcon className="w-6 h-6" />
          <span className="text-xs mt-1">Расходы</span>
        </button>
        <button
          onClick={() => onPageChange('kpi')}
          className={`flex flex-col items-center p-3 transition-colors ${
            currentPage === 'kpi' ? 'text-blue-600' : 'text-gray-500'
          }`}
        >
          <ChartBarIcon className="w-6 h-6" />
          <span className="text-xs mt-1">KPI</span>
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
